import { render, staticRenderFns } from "./MerchantProductDetails.vue?vue&type=template&id=2256094e&scoped=true&"
import script from "./MerchantProductDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./MerchantProductDetails.vue?vue&type=style&index=0&id=2256094e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256094e",
  null
  
)

export default component.exports